/** Abre o widget de chat de IA (AIChatWidget) a partir de qualquer lugar do site. */
export function openChat(e?: { preventDefault?: () => void }) {
  e?.preventDefault?.();
  window.dispatchEvent(new CustomEvent('enq:open-chat'));
}
